import { render, staticRenderFns } from "./ProductDetailHighcharts.vue?vue&type=template&id=609fcb5c"
import script from "./ProductDetailHighcharts.vue?vue&type=script&lang=js"
export * from "./ProductDetailHighcharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports